export interface ScheduleConflictDetails {
  scheduleId: string;
  userId: string;
  userName: string;
  campaignId: string;
  campaignName: string;
  date: string;
  startTime: string;
  endTime: string;
  timeLabel: string;
  dateLabel: string;
}

export function parseScheduleConflictError(err: unknown): {
  message: string;
  conflict: ScheduleConflictDetails | null;
} {
  const data = (err as { response?: { data?: { message?: string; conflict?: ScheduleConflictDetails } } })
    ?.response?.data;

  return {
    message: data?.message || 'Failed to save schedule',
    conflict: data?.conflict || null,
  };
}
